import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";

import "../styles/common.css";
import "../styles/navbar.css";

import logo from "../img/common/logo.svg";
import imgWebsite from "../img/common/illustration_service_website.svg";
import imgMarketing from "../img/common/illustration_service_marketing.svg";
import imgBranding from "../img/common/illustration_service_branding.svg";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container>
      <header className={`nav ${hasScrolled ? "scrolled" : ""}`}>
        <div className="nav-content">
          <div className="nav-logo">
            <a href="/">
              <img src={logo} alt="LOGOT" />
            </a>
          </div>
          <div className="nav-right__sp">
            <div className="button-border__gray button-language nav-button button-icon sp-only">
              <a href="/en"><span>EN</span></a>
            </div>
            <button
              className={`nav-toggle ${isOpen ? "open" : ""}`}
              onClick={() => setIsOpen(!isOpen)}
              aria-label="ナビゲーションメニューの切り替え"
              aria-expanded={isOpen}
              aria-controls="nav-menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div className={`nav-right ${isOpen ? "open" : ""}`}>
            <nav className="header-nav">
              <ul>
                <li><a href="/work">制作実績</a></li>

                {!isMobile ? (
                  <li
                    className="dropdown"
                    onMouseEnter={() => {
                      clearTimeout(window.dropdownTimeout);
                      setIsDropdownOpen(true);
                    }}
                    onMouseLeave={() => {
                      window.dropdownTimeout = setTimeout(() => {
                        setIsDropdownOpen(false);
                      }, 100);
                    }}
                  >
                    <div className="dropdown-wrapper">
                      <button
                        className="dropdown-button"
                        onClick={(e) => e.preventDefault()}
                        aria-label="事業内容"
                      >
                        事業内容
                      </button>
                      {isDropdownOpen && (
                        <div className="dropdown-menu__wrapper">
                          <ul className="dropdown-menu">
                            <li>
                              <a href="/website">
                                <span>Webサイト制作</span>
                                <div className="dropdown-menu__img">
                                  <img src={imgWebsite} alt="" />
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="/marketing">
                                <span>マーケティング支援</span>
                                <div className="dropdown-menu__img">
                                  <img src={imgMarketing} alt="" />
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="/branding">
                                <span>ブランディング支援</span>
                                <div className="dropdown-menu__img">
                                  <img src={imgBranding} alt="" />
                                </div>
                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </li>
                ) : (
                  <>
                    <li><a href="/website">Webサイト制作</a></li>
                    <li><a href="/marketing">マーケティング支援</a></li>
                    <li><a href="/branding">ブランディング支援</a></li>
                  </>
                )}
                <li><a href="/company">会社概要</a></li>
              </ul>
            </nav>
            <div className="nav-buttonArea">
              <div className="button-border__gray button-language nav-button button-icon pc-only">
                <a href="/en"><span>EN</span></a>
              </div>
              <div className="button-gradation button-contact nav-button button-icon">
                <a href="/contact"><span>お問い合わせ</span></a>
              </div>
            </div>
          </div>
        </div>
      </header>
    </Container>
  );
}

export default Navbar;
